// 登録者・作業者などのユーザ表示を統一する。
// グループ有りは「名前（グループ名）」(全角括弧)、グループ無しは名前のみ、ユーザ無しは "-"。

import { InfoListColDef } from "../components/InfoList";

type UserWithGroup = { name: string; Group?: { name: string } | null } | null | undefined;
type UserWithId = { id: string; name: string; Group?: { name: string } | null } | null | undefined;

export function formatUserWithGroup(user: UserWithGroup): string {
  if (!user) {
    return "-";
  }
  if (user.Group) {
    return `${user.name}（${user.Group.name}）`;
  }
  return user.name;
}

// InfoList の「登録者」列。リンクは張らない(ユーザー管理画面は 2026-07-16 に廃止。
// ユーザー管理は system-admin 側の責務のため、console にはテキスト表示のみ残す)。
export function userInfoCol(user: UserWithId): InfoListColDef {
  return {
    label: "登録者",
    context: formatUserWithGroup(user),
  };
}
